import React from "react";
import { Link } from "react-router-dom";
import MarketingLayout from "./components/MarketingLayout.js";
import MarketingFooterCtas from "./components/MarketingFooterCtas.js";

const SECTIONS = [
  {
    id: "builder",
    kicker: "Builder",
    title: "Website Builder",
    items: [
      "Generate a site from the Website Builder and iterate in chat.",
      "Enable standard pages (About, Contact, Privacy, Terms, Cookie, Refund) so footer links stay complete.",
      "Preview updates live in the Preview panel beside chat.",
    ],
  },
  {
    id: "code",
    kicker: "Code",
    title: "Code (Mini-IDE)",
    items: [
      "Generated files appear in the sidebar and stay editable.",
      "Ask for a website or app even with no file selected — Zolaid can create index.html, styles.css, and app.js.",
      "Rename symbol: F2. Quick Fix: Ctrl/Cmd + . or the Problems panel.",
    ],
  },
  {
    id: "terminal",
    kicker: "CLI",
    title: "Terminal",
    items: [
      "Enable backend DevTools with DEVTOOLS_ENABLED=true, then restart the backend.",
      "Set CWD to .zolaid_generated to work with generated project files.",
      "If the stream disconnects, click Stop, then Start again.",
    ],
  },
  {
    id: "faq",
    kicker: "FAQ",
    title: "Common questions",
    items: [
      <>
        <strong>Why are Terminal / repo tools blocked?</strong> DevTools must be enabled on the backend:{" "}
        <code>DEVTOOLS_ENABLED=true</code>.
      </>,
      <>
        <strong>Why didn’t AI create files?</strong> In Code mode with nothing selected, ask for a site or
        app — Zolaid will generate <code>index.html</code>, <code>styles.css</code>, and <code>app.js</code>.
      </>,
      <>
        <strong>Where are generated files stored?</strong> Under <code>.zolaid_generated/</code>.
      </>,
    ],
  },
];

export default function Docs() {
  return (
    <MarketingLayout>
      <div className="marketing-page-content docs-page docs-page--wide">
        <header className="marketing-page-intro">
          <p className="marketing-page-eyebrow">Resources</p>
          <h1>Zolaid Docs</h1>
          <p className="page-lead">
            A short guide to Builder, Code, and Terminal — enough to build, automate, and ship without a
            separate developer portal.
          </p>
        </header>

        <nav className="docs-toc" aria-label="Docs sections">
          {SECTIONS.map((section) => (
            <a key={section.id} href={`#${section.id}`}>
              {section.title}
            </a>
          ))}
        </nav>

        <div className="docs-sections">
          {SECTIONS.map((section) => (
            <section key={section.id} id={section.id} className="marketing-section-card">
              <span className="marketing-kicker" aria-hidden>
                {section.kicker}
              </span>
              <h2 className="marketing-section-title">{section.title}</h2>
              <ul className="marketing-list">
                {section.items.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </section>
          ))}
        </div>

        <div className="marketing-cta-row">
          <Link to="/chatbot" className="marketing-cta">
            Open Zolaid
          </Link>
          <Link to="/Support" className="marketing-cta marketing-cta--secondary">
            Get support
          </Link>
        </div>

        <MarketingFooterCtas />
      </div>
    </MarketingLayout>
  );
}
